import styled, { css } from 'styled-components';

export const DnsWizardLegacyDnsTableWrapper = styled.div`
  ${() => css`
      margin-top: 40px;
      max-width: 100%;
      overflow: hidden;
  `}
`;
